module.exports = __webpack_public_path__ + "media/images/awards/CCA AWARDS ANNOUNCEMENT The Roux_061725-2-tiny-958e78a320f75477540f8125af0ce65b.jpg";